/**
 * APIリクエストを送信する共通ユーティリティ
 * 環境変数 REACT_APP_API_BASE_URL を参照して、ローカルと本番で向き先を切り替えます。
 */

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const fetchData = async (endpoint) => {
    const url = `${API_BASE_URL}${endpoint}`;

    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
    } catch (error) {
        console.error(`API Fetch Error (${url}):`, error);
        throw error;
    }
};
